import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import api from '../services/api';
import './ProgramDetail.scss';

const STATIC_PROGRAMS = {
    code: {
      title: 'CODE',
      subtitle: 'Mindset & Performance',
      tagline: 'Former une génération d\'étudiants mentalement solides, disciplinés et orientés performance durable',
      frequency: 'Tous les 2 mois',
      format: 'En ligne',
      color: '#3B5BA5',
      headerImage: '/assets/IMG/Header_Code.jpg',
      description: 'Programme intensif de transformation du mindset destiné aux jeunes étudiants universitaires ambitieux à fort potentiel. L\'objectif est de former des individus mentalement solides, disciplinés et orientés vers la performance durable.',
      context: 'Dans un monde en constante mutation, la réussite académique ou professionnelle ne dépend plus uniquement des connaissances techniques. Elle repose de plus en plus sur la solidité mentale, la discipline personnelle, la clarté de vision et la capacité à maintenir une performance durable dans le temps. De nombreux jeunes étudiants et talents émergents disposent d\'un fort potentiel, mais rencontrent des difficultés à structurer leur vision de vie et de carrière, à développer une discipline personnelle constante, à gérer la pression et les défis, à maintenir une motivation durable et à transformer leurs ambitions en résultats concrets.',
      justification: 'Face à ces défis, il devient essentiel de former des jeunes capables de développer un mindset d\'excellence, fondé sur la résilience, la responsabilité personnelle et la recherche de performance durable. Le programme CODE répond à cette nécessité en proposant une expérience intensive de transformation du mindset destinée aux étudiants africains.',
      presentation: 'CODE est un programme intensif conçu pour accompagner les étudiants africains dans une transformation profonde de leur manière de penser, d\'agir et de se projeter dans leur avenir. À travers un parcours structuré mêlant formation, réflexion personnelle, défis pratiques et accompagnement, les participants acquièrent les outils nécessaires pour devenir des individus capables d\'exceller dans leurs études, leur carrière et leur engagement sociétal.',
      objectives: [
        'Renforcer la solidité mentale et la résilience des participants',
        'Développer une discipline personnelle et une rigueur dans l\'action',
        'Aider les jeunes à clarifier leur vision de vie et leurs objectifs',
        'Cultiver un état d\'esprit orienté excellence et performance durable',
        'Renforcer les compétences de leadership personnel'
      ],
      modules: [
        { name: 'Leadership & Soft Skills', description: 'Développement des compétences relationnelles et de leadership' },
        { name: 'Excellence académique', description: 'Méthodes et stratégies pour exceller dans les études' },
        { name: 'Performance personnelle', description: 'Optimisation de la productivité et de l\'efficacité' },
        { name: 'Discipline mentale', description: 'Renforcement de la volonté et de la persévérance' },
        { name: 'Résilience & Confiance', description: 'Développement de la confiance en soi et de la résilience' },
        { name: 'Culture de performance', description: 'Adoption d\'une mentalité orientée résultats' }
      ],
      results: [
        'Développer une discipline personnelle forte',
        'Structurer leurs objectifs et leur vision de vie',
        'Renforcer leur résilience face aux difficultés',
        'Adopter un mindset orienté excellence',
        'Maintenir une performance durable dans leurs études et projets'
      ],
      format_details: 'Format intensif combinant sessions de formation, ateliers interactifs, exercices de réflexion personnelle, défis pratiques, accompagnement et mentorat, études de cas, et défis personnels.'
    },
    trajectoire: {
      title: 'TRAJECTOIRE',
      subtitle: 'Orientation & Compétence',
      tagline: '1 filière mise en lumière par an',
      frequency: '1 filière/an',
      format: 'Hybride',
      color: '#E8731A',
      headerImage: '/assets/IMG/Header_Trajectoire.png',
      description: 'Programme structuré qui aide les jeunes étudiants à clarifier leur orientation académique, identifier leurs forces naturelles, construire une stratégie de carrière cohérente et prendre des décisions éclairées. Chaque année, une filière est mise en lumière.',
      pillars: [
        { name: 'Orientation académique', description: 'Clarification du parcours d\'études optimal' },
        { name: 'Clarté professionnelle', description: 'Identification des métiers et opportunités' },
        { name: 'Stratégie de carrière', description: 'Construction d\'un plan de carrière cohérent' }
      ],
      benefits: [
        'Clarté sur les nouveaux métiers de la filière',
        'Compétences à avoir pour exceller',
        'Qualités requises pour réussir',
        'Débouchés possibles en fin de cycle'
      ],
      target: 'Étudiants universitaires en quête d\'orientation et de clarté professionnelle',
      impact: 'Les étudiants obtiennent une vision claire de leur parcours académique et professionnel, avec une compréhension approfondie des opportunités qui s\'offrent à eux.'
    },
    propel: {
      title: 'PROPEL',
      subtitle: 'Programme d\'Intégration et d\'Excellence Professionnelle',
      tagline: '3 jours intensifs + Stage de validation',
      frequency: '3 jours intensifs',
      format: 'Présentiel + Stage de validation',
      color: '#D63070',
      headerImage: '/assets/IMG/Header_Propel.png',
      description: 'Formation intensive destinée aux étudiants ayant obtenu leur BTS, Licence et Master. Chaque année, de nombreux jeunes diplômés quittent les établissements avec des connaissances académiques solides, mais rencontrent des difficultés à s\'intégrer efficacement dans le monde professionnel.',
      objective: 'Préparer les jeunes étudiants et diplômés à une intégration professionnelle réussie en développant leur posture, leur discipline professionnelle et leur capacité à évoluer efficacement dans un environnement de travail.',
      modules: [
        { name: 'Module 1 : Code Pro', description: 'Décrypter les règles implicites et explicites du monde professionnel' },
        { name: 'Module 2 : Posture & Impact', description: 'Développer une posture professionnelle forte, crédible et influente' },
        { name: 'Module 3 : Productivité & Discipline', description: 'Renforcer la discipline, l\'organisation et l\'efficacité dans le travail' },
        { name: 'Module 4 : Maîtrise Administrative', description: 'Produire des documents administratifs conformes aux standards professionnels' },
        { name: 'Module 5 : Lancement & Insertion', description: 'Faciliter l\'accès concret à l\'emploi, au stage ou à l\'engagement associatif' }
      ],
      validation: 'À l\'issue de la formation, chaque participant bénéficie d\'un stage de validation lui permettant d\'expérimenter les compétences acquises, de découvrir un environnement professionnel réel et de renforcer sa crédibilité professionnelle.',
      target: 'Étudiants BTS, Licence et Master',
      impact: [
        'Faciliter l\'insertion professionnelle des jeunes',
        'Renforcer l\'employabilité des étudiants et diplômés',
        'Réduire l\'écart entre formation académique et exigences professionnelles',
        'Préparer une génération de jeunes professionnels compétents et responsables'
      ]
    }
  };

const ProgramDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/programs/${id}`)
      .then(({ data }) => setProgram(data.data))
      .catch(() => setProgram(STATIC_PROGRAMS[id] || null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="program-detail-page">
        <div className="program-loading">
          <div className="program-loading-spinner" />
        </div>
      </div>
    );
  }

  if (!program) {
    return (
      <div className="program-detail-page">
        <div className="program-not-found">
          <h2>Programme non trouvé</h2>
          <button onClick={() => navigate('/programmes')}>Voir tous les programmes</button>
        </div>
      </div>
    );
  }

  return (
    <div className="program-detail-page">
      <PageHeader 
        title={program.title}
        subtitle={program.tagline}
        breadcrumb={['Accueil', 'Programmes', program.title]}
        image={program.headerImage}
        hideText={true}
      />

      <div className="program-content">
        <div className="content-container">
          <section className="program-section">
            <h2>Présentation</h2>
            <p className="description">{program.description}</p>
          </section>

          {program.objectives && (
            <section className="program-section">
              <h2>Objectifs du Programme</h2>
              <ul className="objectives-list">
                {program.objectives.map((obj, index) => (
                  <li key={index}>{obj}</li>
                ))}
              </ul>
            </section>
          )}

          {program.pillars && (
            <section className="program-section">
              <h2>Trois Piliers Fondamentaux</h2>
              <div className="pillars-grid">
                {program.pillars.map((pillar, index) => (
                  <div key={index} className="pillar-card">
                    <h3>{pillar.name}</h3>
                    <p>{pillar.description}</p>
                  </div>
                ))}
              </div>
            </section>
          )}

          {program.modules && (
            <section className="program-section">
              <h2>Modules du Programme</h2>
              <div className="modules-grid">
                {program.modules.map((module, index) => (
                  <div key={index} className="module-card">
                    <div className="module-number">{index + 1}</div>
                    <h3>{module.name}</h3>
                    <p>{module.description}</p>
                  </div>
                ))}
              </div>
            </section>
          )}

          {program.results && (
            <section className="program-section">
              <h2>Résultats Attendus</h2>
              <p>À l'issue du programme, les participants seront capables de :</p>
              <ul className="results-list">
                {program.results.map((result, index) => (
                  <li key={index}>{result}</li>
                ))}
              </ul>
            </section>
          )}

          {program.benefits && (
            <section className="program-section">
              <h2>Bénéfices</h2>
              <ul className="benefits-list">
                {program.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </section>
          )}

          {program.impact && Array.isArray(program.impact) && (
            <section className="program-section">
              <h2>Impact</h2>
              <ul className="impact-list">
                {program.impact.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>
          )}

          {program.validation && (
            <section className="program-section highlight">
              <h2>Stage de Validation</h2>
              <p>{program.validation}</p>
            </section>
          )}

          {program.format_details && (
            <section className="program-section">
              <h2>Format</h2>
              <p>{program.format_details}</p>
            </section>
          )}

          <section className="program-cta">
            <h2>Prêt à rejoindre le programme ?</h2>
            <button className="cta-button" style={{ background: program.color }} onClick={() => navigate('/inscription')}>
              S'inscrire au programme {program.title}
            </button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ProgramDetail;
